import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BaseFieldComponent } from '../base-field.component';

@Component({
  selector: 'app-text-field',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  template: `
    <div class="field-wrapper" [class]="field.cssClass" [class.has-error]="isInvalid">

      <label [for]="field.id">
        {{ field.label }}<a *ngIf="hasLabelLink" [href]="field.linkUrl" [target]="field.linkTarget ?? '_blank'" [attr.rel]="(field.linkTarget ?? '_blank') === '_blank' ? 'noopener noreferrer' : null">{{ field.linkText }}</a>
        <span *ngIf="hasRequired" class="required-mark">*</span>
      </label>

      <input
        [id]="field.id"
        [type]="inputType"
        [formControl]="control"
        [placeholder]="field.placeholder ?? ''"
        [attr.aria-describedby]="field.hint ? field.id + '-hint' : null"
      />

      <small *ngIf="field.hint && !isInvalid && !isPending"
             [id]="field.id + '-hint'">
        {{ field.hint }}
      </small>

      <span *ngIf="isPending" class="field-pending">
        Verificando...
      </span>

      <small *ngIf="isInvalid" class="error">
        {{ errorMessage }}
      </small>

    </div>
  `
})
export class TextFieldComponent extends BaseFieldComponent {

  get inputType(): string {
    const map: Record<string, string> = {
      email: 'email', password: 'password', number: 'number'
    };
    return map[this.field.type] ?? 'text';
  }

  get hasRequired(): boolean {
    return !!this.field.validations?.some(v => v.type === 'required');
  }
}